import fetch from '../../api/fetch'

/**
 *  Action to view a single Policy details
 *
 *  @param  {number} policyId [Policy ID]
 *  @param  {string} URL [/api/v1/policies/:policyId/view]
 *  @method GET
 */
export function getPolicySingle(policyId: number) {

    return {
        type: 'GET_POLICY_SINGLE',
        payload: fetch(
            `/policies/${policyId}/view`
        ),
    }
}

/**
 *  Action to download Schedule
 *
 *  @param  {number} policyId [Policy ID]
 *  @method GET
 */
export function downloadPolicyScheme(policyId: number) {

    return {
        type: 'GET_POLICY_SCHEME',
        payload: fetch(
            `/policies/${policyId}/downloadSchedule`
        ),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/policies/view.ts